import { Component, 
  OnInit, 
  Input, 
  Output, 
  ChangeDetectionStrategy,
  EventEmitter
 } from '@angular/core';

@Component({
  selector: 'nd-button',
  template: `<input type="button"
  [attr.id]="Id"
  class="nd-button {{type}}"
  [ngClass]="classList"
  [class.disabled]="disabled"
  (click)="clickEvent($event)"
  [value]="label"/>
  <ng-content></ng-content>
`,
  styles: [`:host{margin:8px 20px 8px 8px;display:inline-block;position:relative}.nd-button{width:110px;height:38px;border-radius:1px;padding-left:15px;padding-right:15px;border:none;color:#fff;text-align:center;text-decoration:none;text-overflow:ellipsis;overflow:hidden;display:inline-block;font-size:12px;font-weight:600;cursor:pointer;outline:0}.nd-button:active,.nd-button:focus{outline:0}.nd-button.disabled{cursor:default}.nd-button.primary{background-color:#225582}.nd-button.primary:hover{background-color:#39668e}.nd-button.primary:active{background-color:#1e4c74}.nd-button.primary.disabled{background-color:#6488a7;color:#225582}.nd-button.secondary{background-color:#979797}.nd-button.secondary:hover{background-color:#a1a1a1}.nd-button.secondary:active{background-color:#878787}.nd-button.secondary.disabled{background-color:#b6b6b6;color:#979797}.nd-button.multi{background-color:#fff;color:#e66e25;border:1px solid #e66e25}.nd-button.multi:hover{background-color:#e66e25;color:#fff}.nd-button.multi:active{background-color:#d86722}.nd-button.multi.disabled{background-color:#ed9966;color:#e66e25;border-color:#ed9966}`],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ButtonComponent implements OnInit {

  /**  The type of button to be shown, either primary, secondary, or mutli */
  @Input() type: string = "primary";
  /**  The text that should appear as the buttons label */
  @Input() label: string = "OK";
  /** Flag that indicates if the button should be disabled or not */
  @Input() disabled: boolean = false;
  @Input() classList: string | string[];
  @Input() Id: string;

  @Output("onClick") buttonClickEvent: EventEmitter<Event> = new EventEmitter();

  constructor() { }

  ngOnInit() {
    //  Ensure the value passed in for type is one of the three allow options
    if(this.type !== "primary" && this.type !== "secondary" && this.type !== "multi"){
      this.type = "primary";
    }
  }

  public clickEvent(e: MouseEvent){
    if(!this.disabled){
      this.buttonClickEvent.emit(e);    
    }
  }

}
